
import http from '@/components/services/http-common';
import moment from 'moment/moment';
export default {
    props:["value", "item", "employee"],
    watch:{
        employee(val) {
            console.log("has employee");
        },
        value: {
            handler(val){
                if(val)
                {
                    if(this.isEdit)
                        this.fetch();
                }
                else{
                    this.close();
                }
            }
        },
        'form.quitDate'(val) {
            if (val && this.form.quitTypeCode === 'TS') {
                this.form.validTo = moment(val).add(6, 'months').format('YYYY-MM-DD');
            }
        },
        'form.quitTypeCode'(val) {
            if (val === 'TS' && this.form.quitDate) {
                 this.form.validTo = moment(this.form.quitDate).add(6, 'months').format('YYYY-MM-DD');
            } else if (val !== 'TS' && val !== 'TN') {
                 this.form.validTo = null;
            }
        }
    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        },
        todayDate() {
            return moment().format('YYYY-MM-DD');
        },
        quitDateMinLimit() {
            if (this.form.quitTypeCode === 'TS' && this.form.dueDate) {
                const twoMonthsBefore = moment(this.form.dueDate).subtract(2, 'months').format('YYYY-MM-DD');
                return moment(this.todayDate).isAfter(twoMonthsBefore) ? this.todayDate : twoMonthsBefore;
            }
            return this.todayDate;
        },
        quitDateRules() {
            const rules = [
                v => !!v || 'Vui lòng chọn ngày',
                v => (!v || v >= this.todayDate) || 'Không được chọn ngày trong quá khứ'
            ];
            if (this.form.quitTypeCode === 'TS' && this.form.dueDate) {
                const limit = moment(this.form.dueDate).subtract(2, 'months').format('YYYY-MM-DD');
                rules.push(v => (!v || v >= limit) || 'Không được quá 2 tháng trước ngày dự sinh');
            }
            return rules;
        }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",

            isValid: true,
            fetchData: false,
            isUploading: false,
            form: {
                quitDate: null,
                quitReason:"",
                quitTypeCode: '',
                isAgreeTerm: 0,
                dueDate: null,
                attachment: "",
                pregnancyFile: "",
                validTo: null,
            },
            defaultForm:{
                quitDate: null,
                quitReason:"",
                quitTypeCode: '',
                isAgreeTerm: 0,
                dueDate: null,
                attachment: "",
                pregnancyFile: "",
                validTo: null,
            },
            attachmentFile: null,
            pregnancyFileInput: null,
            quitReasons: [
                "Khác",
            ],
            quitTypes: [],
            term: '',
        }
    },
    methods: {
        uploadAttachment(file) {
            if (!file) {
                this.form.attachment = '';
                return;
            }
            if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
                alert("Đính kèm bắt buộc phải là định dạng PDF.");
                this.attachmentFile = null;
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            this.fetchData = true;
            this.isUploading = true;
            http.post("NasUploads?folder=QuitRequest", formData).then(res => {
                this.form.attachment = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
            }).finally(() => {
                this.fetchData = false;
                this.isUploading = false;
            });
        },
        uploadPregnancyFile(file) {
            if (!file) {
                this.form.pregnancyFile = '';
                return;
            }
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type) && !file.name.match(/\.(pdf|jpe?g|png)$/i)) {
                alert("Chứng từ thai sản chỉ hỗ trợ định dạng PDF hoặc hình ảnh (JPG, PNG).");
                this.pregnancyFileInput = null;
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            this.fetchData = true;
            this.isUploading = true;
            http.post("NasUploads?folder=QuitRequest", formData).then(res => {
                this.form.pregnancyFile = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
            }).finally(() => {
                this.fetchData = false;
                this.isUploading = false;
            });
        },
        fetch(employee = false){
            this.fetchData =true;
            return http.get(this.ROOT_URL+this.item.code).then(res => {
                this.form = Object.assign({}, res.data);
                this.fetchData =false;
            })
        },
        getTypes() {
            return http.get(this.ROOT_URL+"types").then(res => res.data).then(d => {
                this.quitTypes = [...d.data]
            })
        },
        setTerm() {
            let selected = this.form.quitTypeCode
            this.term = this.quitTypes.find(x=>x.code == selected)?.term
        },

        saveData() {
            if (this.isUploading) {
                alert("Vui lòng chờ file tải lên hoàn tất trước khi gửi.");
                return;
            }
            this.$refs.form.validate();
            if(this.isValid)
            {
                if(this.form.quitTypeCode == "TS" && !this.form.dueDate ) {
                    alert("Bạn nhập ngày dự sinh khi ở trạng thái thai sản")
                    return
                }
                if(!this.isEdit){
                    if(this.form.isAgreeTerm ==0) {
                        alert("Bạn chưa đồng ý với các điều kiện trên")
                        return
                    }
                    this.fetchData = true;
                    return http.post(this.ROOT_URL+"personal", this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    }).finally(() => {
                        this.fetchData = false;
                    });
                }else {
                    alert("Đang phát triển")
                    return false
                }
            }
        },
        close(){
            this.form = Object.assign({}, this.defaultForm);
            this.$refs.form.resetValidation();
            this.terms = ''
            this.fetchData=false;
            this.attachmentFile = null;
            this.pregnancyFileInput = null;
        },
        getNextDay(dateStr) {
            if (!dateStr) return this.todayDate;
            return moment(dateStr).add(1, 'days').format('YYYY-MM-DD');
        }
    },
    created() {
        this.getTypes()
    }
}